export default {"src":"/_next/static/media/chevronRightDouble_24.eaa1ed28.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};